import React, { ReactNode } from "react";

import classNames from "classnames";
import { useIntl } from "gatsby-plugin-react-intl";

import Logo from "../logo/logo";
import Navigation from "../navigation/main/navigation";

interface HeaderProps {
  hideNavigation?: boolean;
  headerLogo?: ReactNode;
}

const isGroup = process.env.GATSBY_SITE === "group";
const isAsia = process.env.GATSBY_SITE === "asia";

const Header: React.FC<HeaderProps> = ({
  hideNavigation = false,
  headerLogo = undefined,
}) => {
  const intl = useIntl();

  return (
    <header
      className={classNames(
        "header",
        {
          "h-auto py-18": hideNavigation,
          "header--asia": isAsia,
          "header--group": isGroup,
        },
      )}
    >
      {hideNavigation ? (
        <a href="/" title={intl.formatMessage({ id: "navigation.logo_title" })}>
          {headerLogo || <Logo breakpoint="lg" />}
        </a>
      ) : (
        <Navigation isAsia={isAsia} isGroup={isGroup} />
      )}
    </header>
  );
};

export default Header;
